export default "__VITE_ASSET__Btd7zHNw__"